<template>
  <div id="activate-account-view">
    <v-content>
      <v-container>
        <v-layout justify-center row wrap>
          <v-flex xs12 sm8 md6>
            <v-card
              max-width="800px"
              elevation=24
            >
            <v-toolbar dark color="primary">
              <v-toolbar-title>{{ title }}</v-toolbar-title>
            </v-toolbar>

            <v-layout align-center justify-center row fill-height>
              <router-link to="/">
                <img :src="require('../assets/fuzzcv-logo.png')" alt="fuzzcv curriculum vitae CV automatique en ligne" width="400" class="mt-3">
              </router-link>
            </v-layout>

            <v-layout align-center justify-center row fill-height
                v-if="activationLoading">
                <v-progress-circular
                  :size="70"
                  :width="7"
                  indeterminate
                  color="primary"
                  class="text-xs-center mb-5"
                ></v-progress-circular>
              </v-layout>

              

              <v-card-actions>
                <v-layout wrap>
                  <v-flex xs12>
                    <div class="my-3">
                      <v-alert v-if="activationError"
                        :value="true"
                        type="warning"
                      >
                        {{ activationRaisonError }}
                      </v-alert>

                      <v-alert v-else-if="activationCompleted"
                        :value="true"
                        type="success"
                      >
                        {{ sucessMsg }}
                      </v-alert>

                      <v-alert v-else
                        :value="true"
                        type="warning"
                      >
                        {{ errorMsg }}
                      </v-alert>
                    </div>

                  </v-flex>
                </v-layout>
              </v-card-actions>
             
              <v-card-text>
                <router-link v-if="!isAuthenticated" to="/login">
                 {{ backToLoginPageLabel }}
                </router-link>
              
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapState,
} from 'vuex';

export default {
  data: function() {
    return {
      title: "Vérificaton de l'email.",
      sucessMsg: "Votre compte a été créé avec succès!",
      errorMsg: "Une erreur s'est produite.",
      backToLoginPageLabel: "Cliquez ici pour utiliser l'application avec votre compte.",
    }
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapState('signup', [
      'activationCompleted',
      'activationError',
      'activationLoading',
      'activationRaisonError',
    ]),
  },
  methods: mapActions('signup', [
    'activateAccount',
    'clearActivationStatus',
  ]),
  created() {
    this.activateAccount(this.$route.params);
  },
  beforeRouteLeave(to, from, next) {
    this.clearActivationStatus();
    next();
  },
};
</script>


<style>
  #activate-account-view {
    background-image: url('../assets/hands-joined-team.jpg');
    /* background-color: #8f2c2c; */
    height: 100vh;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }
</style>
